import React, { useEffect } from 'react';
import './ContactPage.css';
import SEO from '../SEO';
import Crow from '../images/crow.mp4';
import ContactFormNew from './ContactFormNew';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import Footer from './footer.js';
import { useScrollBehavior } from './useScrollBehavior.js';

const ContactPageNew = () => {
  useScrollBehavior();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const title = 'Contact Yokai Software | Web Design, Development, SEO, and App Solutions';
  const description =
    'Contact Yokai Software to discuss web design, web development, SEO, app development, chatbots, and full-stack digital solutions for your business.';
  const canonical = 'https://yokaisoftware.com/contact-new';
  const image = 'https://yokaisoftware.com/apple-touch-icon(1)_crow_logo.png';

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'https://yokaisoftware.com/#organization',
        name: 'Yokai Software',
        url: 'https://yokaisoftware.com/',
        logo: 'https://yokaisoftware.com/apple-touch-icon(1)_crow_logo.png',
        email: 'contact@yokaisoftware.com',
        telephone: '+1-941-613-4645',
        description:
          'Yokai Software provides web design, web development, SEO, app development, chatbot development, and full-stack digital solutions for businesses.',
      },
      {
        '@type': 'ContactPage',
        '@id': 'https://yokaisoftware.com/contact-new#webpage',
        url: 'https://yokaisoftware.com/contact-new',
        name: title,
        description,
        isPartOf: {
          '@id': 'https://yokaisoftware.com/#website',
        },
        about: {
          '@id': 'https://yokaisoftware.com/#organization',
        },
      },
    ],
  };

  return (
    <div className="contact-page-new">
      <SEO
        title={title}
        description={description}
        canonical={canonical}
        image={image}
        schema={schema}
      />

      <section className="contact-page-new-hero">
        <video autoPlay muted loop playsInline preload="auto">
          <source src={Crow} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="contact-page-new-hero-content">
          <h1>Contact Us</h1>
          <h2>Let&apos;s Build Something Together</h2>
        </div>
      </section>

      <section className="contact-page-new-main">
        <div className="contact-page-new-form-col">
          <ContactFormNew />
        </div>

        <div className="contact-page-new-info-col">
          <div className="contact-page-new-intro">
            <h1>Tell Us What You Need</h1>
            <p>
              Whether you need web design, development, SEO support, chatbot
              implementation, or a more structured digital system, this is the
              right place to start.
            </p>
          </div>

          <div className="contact-page-new-direct">
            <h2>Direct Contact</h2>
            <p>contact@yokaisoftware.com</p>
            <p></p>
          </div>

          <div className="contact-page-new-socials">
            <a
              href="https://www.facebook.com/profile.php?id=61559579340148&mibextid=LQQJ4d"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebook size={46} className="facebook" />
            </a>

            <a
              href="https://www.instagram.com/yokaisoftware?igsh=MTBjbWhiM294NXNxbA%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram size={46} className="instagram" />
            </a>

            <a
              href="https://www.linkedin.com/company/yokai-software-and-web-development/about/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin size={46} className="linkedin" />
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPageNew;